module.exports = __webpack_public_path__ + "static/P2101468-a0d7778c4e536df0f9f8f2ae22e133eb.jpg";